/**
 * Public /terms page (C23).
 *
 * Placeholder terms pending formal legal review (the page says so). As with
 * /privacy, the load-bearing requirement is a clear public contact path.
 */
import Alert from "@mui/material/Alert";
import Container from "@mui/material/Container";
import Link from "@mui/material/Link";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { createFileRoute } from "@tanstack/react-router";

const CONTACT_EMAIL = "contact@records-monitor.example";

function TermsPage() {
  return (
    <Container maxWidth="md" sx={{ mt: 4 }}>
      <Stack spacing={3}>
        <Typography variant="h4" component="h1">
          Terms of Service
        </Typography>

        <Alert severity="info">
          These terms are a working draft pending formal legal review. The authoritative version
          will replace this text before public launch.
        </Alert>

        <Typography variant="body1">
          Records Monitor is provided on a best-effort basis. We index public records from
          third-party government websites and cannot guarantee that every record is complete,
          current, or accurate. Always consult the official source for authoritative records.
        </Typography>

        <Typography variant="body1">
          You agree to use the service lawfully and not to abuse, overload, or attempt to circumvent
          access controls on the service or on the upstream government sites it indexes.
        </Typography>

        <section aria-labelledby="terms-contact-heading">
          <Typography id="terms-contact-heading" variant="h5" component="h2" gutterBottom>
            Contact
          </Typography>
          <Typography variant="body1">
            Questions about these terms, or reports of abuse, should be sent to{" "}
            <Link href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</Link>.
          </Typography>
        </section>
      </Stack>
    </Container>
  );
}

export const Route = createFileRoute("/terms")({
  component: TermsPage,
});
